<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="(menu, menuCount) in menus" >
            <v-list-group
            :key="menu.pageTypeDesc"
            prepend-icon="mdi-chevron-down"
            append-icon=""
            dense
            style="background-color:#1565C0;text-color:white;color:white;font-color:white"
            class="pa-0"
          >
            <template v-slot:activator>
              <v-list-item-content >
                <v-list-item-title style="color:white;">
                  {{ menu.pageTypeDesc }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="(child, i) in menu.pages"
              :key="i"
              link
              style="background-color:white"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content v-on:click="itemClick(child)">
                <v-list-item-title class="pl-8">
                  &nbsp;&nbsp; {{ child.pageName }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            </v-list-group>


            <v-divider :key="menuCount" class="my-0"/>
        </template>

        <!-- <v-list-group
        prepend-icon="mdi-logout-variant"
        append-icon=""
        style="background-color:#1565C0;">
          <template v-slot:activator>
              <v-list-item-content @click="doLogout()">
                <v-list-item-title
                style="text-color:white;color:white;font-color:white"
                >
                  ออกจากระบบ
                </v-list-item-title>
              </v-list-item-content>
            </template>
        </v-list-group> -->
      </v-list>
    </v-navigation-drawer>
 
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      style="padding-right:20px"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-avatar :tile="true">
        <v-img src="@/assets/skg-logo-2023.png" aspect-ratio="0.5" ></v-img>
      </v-avatar>
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pr-2 pl-4 d-flex child-flex"
      >
        <span class="hidden-sm-and-down">SK Group</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-avatar color="indigo">
          <v-icon >mdi-account-circle</v-icon>
        </v-avatar>
      <v-toolbar-title
        class="ml-0 pr-2 pl-4 d-flex child-flex"
      > ชื่อผู้ใช้งาน : {{username}}
      </v-toolbar-title> -->
      <v-menu open-on-hover bottom  offset-y>
      <template v-slot:activator="{ on, attrs }">
         <v-avatar color="indigo">
          <v-icon dark>mdi-account-circle</v-icon>
        </v-avatar>
        <v-btn
          text
          dark
          v-bind="attrs"
          v-on="on"
        >
          <h4> &nbsp;{{username}}</h4>
        </v-btn>
        
      </template>
      <v-list>
        <v-list-item key="changePass" @click="changePass()">
          <v-list-item-title>
            เปลี่ยนรหัสผ่าน
          </v-list-item-title>
        </v-list-item>
        <v-list-item key="logout"  @click="doLogout()">
          <v-list-item-title>
            ออกจากระบบ
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    </v-app-bar>
   
<v-dialog v-model="modal" max-width="400px" persistent >
        <v-card>
            <v-card-title primary-title> 
                <b>เปลี่ยนรหัสผ่าน</b> </v-card-title>        
            <v-divider></v-divider>    
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field :rules="[rules.required]" autofocus label="รหัสผ่านใหม่" type="password" v-model="password" @keyup.enter.native="doLogin"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
           <v-divider></v-divider>   
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="primary" v-on:click="save">ตกลง</v-btn>
                <v-btn color="primary" v-on:click="close">ยกเลิก</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>
/* eslint-disable */

import {logout} from '@/api/authen-api.js'
import {getMenu, setCurrentPage, clearSession} from '@/assets/js/common.js'
import {changePassword} from '@/api/master/user-api.js'

export default {
  name: 'MenuHeader',
  props: ["userImg", "menu"],
  computed: {
    username() {
      this.menus = getMenu();
      return "ชื่อผู้ใช้งานระบบ : " + this.$store.getters.getUser;
    }
  },
  data() {
      return {
          modal: false,
          drawer: true,
          password: '',
          menus: [],
          rules: {
            required: value => !!value || 'Required.'
        }
      }
  },
  methods: {
      itemClick(page) {
        if (!page) {
          doLogout();
          return;
        }
        //setCurrentPerm(page.pageFunction);
        setCurrentPage(page);
        this.$router.push({name: page.pageUrl, params: {pageCode: page.pageCode, pageName: page.pageName}});
      },
      doLogout() {
        logout(this.username).then(() => {
          clearSession();
          window.location = "/";
        }).catch((e) => {
          console.log(e);
          clearSession();
          window.location = "/";
        });
      },
       changePass() {
        this.modal = true;
      },
      save() {
            changePassword(this.username, this.password).then(rs => {
                this.close();
            });
        },
        close() {
            this.modal = false;
            this.password = '';
            this.$loading(false);
        }
  }
};
</script>